import {App as StdApp} from "@std/app";

import "@main/helpers/globals";

export class App extends StdApp {
    constructor(config = {}) {
        super(config);
    }

    run() {}
}

require("fslightbox");

import "@main/prevent-preload-transition";
import "@main/components/sliders";
import "@main/components/show-more-items";
import "@main/components/accordion";
import "@main/components/video-modal";
import "@main/components/phone-mask";
import "@main/components/phone-mask-country";
import "@main/components/input-filled";
import "@main/components/form-basic";
import "@main/components/close-modal";
import "@main/components/text-tooltip";
import "@main/components/tippy-tooltip";
import "@main/components/show-more-cards";
import "@main/components/map";
import "@main/components/tabs";
import "@main/components/perfect-scroll";
import "@main/components/show-more-program-cards";
import "@main/components/text-toggle";
import "@main/components/show-more-faq";
import "@main/components/article-aside";
import "@main/components/show-link-all-news";
import "@main/components/download-file";
import "@main/components/text-collapsed";
import "@main/components/will-study-list";
import "@main/components/side-nav";
import "@main/components/datepicker";
import "@main/components/clipboard";
import "@main/components/select";
import "@main/components/one-window-form";
import "@main/components/show-more-info-cards";
import "@main/components/search";
import "@main/components/article";
import "@main/components/partners-cards";
import "@main/components/anchoring";
import "@main/components/ask-question-modal";
import "@main/components/questionnaire-modal";
import "@main/components/send-request-modal";
import "@main/components/date-mask";
import "@main/components/job-requirements-modal";
import "@main/components/show-main-block-detail";
import "@main/components/recruitment-modal";
import "@main/components/burger-menu";
import "@main/components/share/";
import "@main/components/exam-calculator";
import "@main/components/career-guidance-test";
import "@main/components/partner-vacancies";
import "@main/components/vacancy-description";
import "@main/components/apply-modal";
import "@main/components/subject-preparation-modal";
import "@main/components/military-record";
import "@main/components/apply-modal-child";
import "@main/components/international-questionnaire-modal";
import "@main/components/biography-modal";
import "@main/components/add-show-more-button";
import "@main/components/show-more-text";
import "@main/rector-page";
import "@main/components/modal-about-student";
import "@main/components/one-line-link-to-student";
import "@main/components/notification";
import "@main/components/show-hidden-text";
import "@main/components/open-career-modal";
import "@main/components/password-icon";
import "@main/components/modal-requirements";
import "@main/components/kwu-form";
import "@main/components/map-ethiopia";
import "@main/components/phone-mask-ethiopia";
import "@main/components/burger-anchor-link";
import "@main/components/teacher-modal";
import "@main/components/start-animate";
import "@main/components/input-messenger";
import "@main/components/events-section";
import "@main/components/cookie";
